import api from './api';

const Qs = require('qs');

const WaitFor = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

let hasWaited = false;

export default async function fetchCourses(search = "", filters = "", sort = "") {
	try {
		const [res] = await Promise.all([
			api.get( '/items/', { params: { 
				...(search ? { search } : {}),
				...(filters.tags ? { tag: filters.tags } : {}),
				...(filters.starts ? { startDateType: filters.starts } : {}),
				...(filters.openEnrollment ? { openEnrollment: filters.openEnrollment } : {}),
				...(filters.duration ? { durationType: filters.duration } : {}),
				...(sort ? { sort } : {}),
			},
			paramsSerializer: function(params) {
				return Qs.stringify(params, {arrayFormat: 'repeat'})
			}}),
			WaitFor(hasWaited ? 400 : 600),
		]);
		if (res.data) {
			hasWaited = true;
			return res.data;
		} else {
            return res;
        }
	} catch (err) {
		// todo: do something when it fails
	}
	return [];
}